import { getOfferTypeClassificationType } from "./get-offer-type-classification";
import type { MakeEntityT } from "@/app/types/offers";

/**
 * Get appropriate financing disclaimer based on offer types and make
 *
 * @param make - The make object containing disclaimer texts
 * @param offerTypes - Array of offer types to determine classification
 * @returns The appropriate disclaimer text or null if not available
 */
export const getFinancingDisclaimer = ({
  make,
  offerTypes,
}: {
  make?:
    | MakeEntityT
    | {
        financing_disclaimer_business?: string | null;
        financing_disclaimer_private?: string | null;
      }
    | null;
  offerTypes: Array<{ label: string; key?: string }> | null;
}): string | null => {
  if (!make) {
    return null;
  }

  const privateDisclaimer =
    "financing_disclaimer_private" in make
      ? (make.financing_disclaimer_private ?? null)
      : null;
  const businessDisclaimer =
    "financing_disclaimer_business" in make
      ? (make.financing_disclaimer_business ?? null)
      : null;

  const offerTypeClassification = getOfferTypeClassificationType(offerTypes);

  switch (offerTypeClassification) {
    case "private":
      return privateDisclaimer;
    case "business":
      return businessDisclaimer;
    case "mixed":
      // For mixed offers, show both disclaimers if available
      if (privateDisclaimer && businessDisclaimer) {
        return `${privateDisclaimer}\n\n${businessDisclaimer}`;
      }
      return privateDisclaimer || businessDisclaimer;
    default:
      // Default to business disclaimer for unknown types
      return businessDisclaimer;
  }
};
